import React from 'react';

import style from './index.module.scss';

const KimSummaryInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Общие итоги по закупкам КИМ</h1>

    <div className={style.description}>
      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>
          С помощью набора фильтров можно посмотреть общие информацию по проведенным закупкам в КИМ в части количества
          позиций, ценовых запросов, организаторов, поставщиков и др.
        </div>
      </div>
    </div>
  </>
);

export default KimSummaryInfo;
